import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../utils/api';

const AppContext = createContext();

export function AppProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [kullanicilar, setKullanicilar] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Sayfa yüklendiğinde token ve kullanıcıyı doğrula
    const initAuth = async () => {
      const savedUser = localStorage.getItem('currentUser');
      const token = api.getAuthToken();
      
      if (savedUser && token) {
        try {
          // Token'ı doğrula
          const res = await api.verifyToken();
          if (res.data.success) {
            setCurrentUser(res.data.kullanici);
          } else {
            // Token geçersiz, temizle
            logout();
          }
        } catch (e) {
          console.error('Token doğrulama hatası:', e);
          // Token geçersiz veya süresi dolmuş
          logout();
        }
      }
      setIsLoading(false);
    };
    
    initAuth();
    loadKullanicilar();
  }, []);

  const loadKullanicilar = async () => {
    try {
      const res = await api.getKullanicilar();
      setKullanicilar(res.data);
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };

  const login = async (kullaniciId, sifre) => {
    const res = await api.login(kullaniciId, sifre);
    if (res.data.success) {
      // Token'ı kaydet
      api.setAuthToken(res.data.token);
      // Kullanıcıyı kaydet
      setCurrentUser(res.data.kullanici);
      localStorage.setItem('currentUser', JSON.stringify(res.data.kullanici));
      return res.data;
    }
    throw new Error('Giriş başarısız');
  };

  const selectUser = (user) => {
    setCurrentUser(user);
    localStorage.setItem('currentUser', JSON.stringify(user));
  };

  const logout = () => {
    setCurrentUser(null);
    api.removeAuthToken();
    localStorage.removeItem('currentUser');
  };

  // Yükleniyor durumunda bekle
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-textSecondary">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <AppContext.Provider value={{ 
      currentUser, 
      selectUser, 
      login, 
      logout, 
      kullanicilar, 
      loadKullanicilar 
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
}
